import { render, staticRenderFns } from "./RespondsTab.vue?vue&type=template&id=e8613934&scoped=true"
import script from "./RespondsTab.vue?vue&type=script&lang=js"
export * from "./RespondsTab.vue?vue&type=script&lang=js"
import style0 from "./RespondsTab.vue?vue&type=style&index=0&id=e8613934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8613934",
  null
  
)

export default component.exports